import { Navigate } from "react-router-dom";
import Home from '../pages/Home';
import Legislation from '../pages/Legislation';
import ContactUs from '../pages/ContactUs';
import AreaMacedonia from '../pages/AreaMacedonia';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import CookiesPolicy from '../pages/CookiesPolicy';

const Route = [
    {
        path: "/",
        element: (
            <Home />
        ),
    },
   
    {
        path: "/legislation",
        element: (
            <Legislation />
        ),
    },
    {
        path: "/contact-us",
        element: (
            <ContactUs />
        ),
    },
    {
        path: "area/:country/:area",
        element: (
            <AreaMacedonia />
        ),
    },
    {
        path: "/privacy-policy",
        element: (
            <PrivacyPolicy />
        ),
    },
    {
        path: "/cookies-policy",
        element: (
            <CookiesPolicy />
        ),
    },
    {
        path: "*",
        element: (
            <Navigate to="/" />
        ),
    },
]

export default Route;